import { useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Shared purchase flow: if logged in -> Stripe checkout; else -> Google login (resumes after).
export function useCheckout() {
  const { user, openAuth } = useAuth();

  const start = useCallback(
    async (planId, billing = "monthly") => {
      if (!user) {
        localStorage.setItem("kiddio_pending_plan", JSON.stringify({ planId, billing }));
        openAuth();
        return;
      }
      try {
        const { data } = await api.post("/payments/checkout", {
          plan_id: planId,
          billing,
          origin_url: window.location.origin,
        });
        window.location.href = data.checkout_url;
      } catch (e) {
        alert("No se pudo iniciar la compra. Inténtalo de nuevo.");
      }
    },
    [user, openAuth]
  );

  return { start };
}
